/* yb-atc-ajax.js — "Agregar al carrito" por AJAX para el tema nulled (le falta product-form.js).
 *
 * Por qué existe: este Shrine es pirata y NO trae el carrito AJAX de Dawn, asi que el boton
 * "Agregar al carrito" hace un envio NATIVO que recarga la pagina hacia /cart. Esa recarga:
 *   - impide que UpCart abra su cajon (UpCart solo abre si el add ocurre sin recargar), y
 *   - se sentia como "no funciona el cajon".
 *
 * Que hace: intercepta el submit del form principal del producto (el que lleva la propiedad
 * properties[__kaching_bundles] que mantiene Kaching), y agrega por /cart/add.js SIN recargar,
 * con la CANTIDAD correcta del paquete elegido en Kaching (Single=1, Duo=2, BxGy=buy+get),
 * leida de kachingBundlesApi.fetchDeals(). Luego abre el cajon de UpCart.
 *
 * Determinista: construye el mismo request que ya verificamos da $59.50 (Duo). No depende de
 * que Kaching/UpCart "ganen" la interceptacion del click.
 *
 * Reversible: borrar este archivo + quitar su <script> de layout/theme.liquid y el tema vuelve
 * al envio nativo (que tambien vende, via pagina /cart). Relacionado: bundle Kaching + UpCart.
 */
(function () {
  'use strict';

  var DEALS = null;

  function ensureDeals() {
    if (DEALS) return Promise.resolve();
    try {
      if (window.kachingBundlesApi && typeof window.kachingBundlesApi.fetchDeals === 'function') {
        return window.kachingBundlesApi.fetchDeals()
          .then(function (d) { DEALS = d; })
          .catch(function () {});
      }
    } catch (e) {}
    return Promise.resolve();
  }

  // Cantidad real que debe entrar al carrito segun el paquete (bid) seleccionado en Kaching.
  function bundleQuantity(propValue) {
    try {
      var bid = JSON.parse(atob(propValue)).bid;
      if (!bid || !DEALS) return 1;
      for (var i = 0; i < DEALS.length; i++) {
        var bars = (DEALS[i] && DEALS[i].dealBars) || [];
        for (var j = 0; j < bars.length; j++) {
          var b = bars[j];
          if (b.id === bid) {
            if (b.dealBarType === 'bxgy') return (b.buyQuantity || 1) + (b.getQuantity || 0);
            return b.quantity || 1;
          }
        }
      }
    } catch (e) {}
    return 1;
  }

  function openUpcart() {
    var ok = false;
    try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (e) {}
    try { if (typeof window.upcartOpenCart === 'function') { window.upcartOpenCart(); ok = true; } } catch (e) {}
    return ok;
  }

  function mainForm(form) {
    return !!(form && form.querySelector && form.querySelector('[name="properties[__kaching_bundles]"]'));
  }

  function onSubmit(e) {
    var form = e.target;
    if (!mainForm(form)) return; // otros forms (p.ej. installment): no tocar

    e.preventDefault();
    e.stopImmediatePropagation(); // tomamos control total del add (sin doble agregado)

    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) { try { form.submit(); } catch (x) {} return; }

    var propInput = form.querySelector('[name="properties[__kaching_bundles]"]');
    var propValue = propInput ? propInput.value : null;

    var btn = form.querySelector('[type="submit"], [name="add"]');
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
    var spinner = form.querySelector('.loading__spinner, .loading-overlay__spinner');
    if (spinner) spinner.classList.remove('hidden');

    ensureDeals()
      .then(function () {
        var qty = propValue ? bundleQuantity(propValue) : 1;
        var item = { id: idInput.value, quantity: qty };
        if (propValue) item.properties = { '__kaching_bundles': propValue };
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [item] })
        });
      })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) { window.location.href = '/cart'; return; } // error -> fallback nativo
        if (!openUpcart()) {
          // UpCart aun no respondio: reintentar una vez; ultimo recurso, pagina /cart
          setTimeout(function () { if (!openUpcart()) window.location.href = '/cart'; }, 450);
        }
      })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () {
        if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
        if (spinner) spinner.classList.add('hidden');
      });
  }

  document.addEventListener('submit', onSubmit, true); // capture: corre antes que cualquier otro handler
  ensureDeals(); // precarga de deals
  window.addEventListener('load', ensureDeals);
})();
